import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AgroDealerRouteProps {
  children: React.ReactNode;
}

const AgroDealerRoute: React.FC<AgroDealerRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || (user?.role !== 'agro_dealer' && user?.role !== 'farmer')) {
    return <Navigate to="/marketplace" replace />;
  }

  return <>{children}</>;
};

export default AgroDealerRoute;
